import React, { useEffect, useState } from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import WatchGuardianLogo2 from "../../Images/WatchGuardianLogo2.png";
import "./sidebar.scss";
import { database } from "../../firebase";
import { ref, get } from "firebase/database";

const SideBarForRole7 = () => {
  const navigate = useNavigate();
  const { currentUser, dispatch: authDispatch } = useContext(AuthContext);
  const [companyLogo, setCompanyLogo] = useState(null);
  const companyId = currentUser.companyId;
  const locationId = currentUser.locationId;
  
  const handleLogout = (e) => {
    e.preventDefault();
    authDispatch({ type: "LOGOUT" });
    navigate(`/watch-swap/${companyId}/${locationId}/login`);
  };

  useEffect(() => {
    if (companyId) {
      const companyRef = ref(database, `Companies/${companyId}`);
      get(companyRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setCompanyLogo(data.companyImage || null);
        }
      });
    }
  }, [companyId]);

  

  return (
    <div className="sidebar">
      <div className="top">
      <img
          src={companyLogo || WatchGuardianLogo2}
          alt="Company Logo"
          className="logo"
          style={{
            maxWidth: "120px",
            height: "auto",
            margin: "0 auto",
            display: "block",
            padding: "10px 0",
          }}
        />
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">USER</p>
          <li onClick={handleLogout}>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideBarForRole7;
